import React, { useMemo, useRef, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
import BrowseItem, { BROWSE_ITEM_MAX_WIDTH } from '../molecules/BrowseItem'
import GridFlatList from '../molecules/GridFlatList'
import { FETCH_OFFERS } from 'dealer-reducers'
import { ListOffer } from 'dealer-types'

interface Props extends Record<string, unknown> {}

const InfinitiveGrid = (props: Props): JSX.Element => {
  const [showList, setShowList] = useState(false)
  const { offers } = useSelector((state: RootReducer) => state.offersListReducer.browse)
  const { columns } = useSelector((state: RootReducer) => state.layoutReducer)
  const tab = useSelector((state: RootReducer) => state.offersListReducer.tab)
  const buyNowFiler = useSelector((state: RootReducer) => state.tableToolsReducer.filters[tab].buyNowFiler)
  const filters = useSelector((state: RootReducer) => state.tableToolsReducer.filters[tab])
  const fullFilters = useMemo(() => ({ ...filters, buyNowFiler }), [filters, buyNowFiler])
  const dispatch = useDispatch()
  const headerHeight = 200
  const gridRef = useRef<HTMLDivElement>(null)

  const itemsPerRowBase = Math.ceil((gridRef.current?.clientWidth ?? 1) / BROWSE_ITEM_MAX_WIDTH)

  useEffect(() => {
    if (gridRef.current !== null) {
      setShowList(true)
    }
  }, [dispatch, filters])

  return (
    <div
      ref={gridRef}
      style={{ height: `calc(100vh - ${headerHeight}px)` }}
      className="ml-[-5px] mr-[-5px] hide-scrollbar">
      {showList && (
        <GridFlatList
          filters={fullFilters}
          data={offers}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          component={(itemProps: ListOffer) => (
            <BrowseItem
              label1={itemProps.label1}
              label2={itemProps.label2}
              highestBet={itemProps.highest_bet}
              photo={itemProps.photo}
              score={itemProps.score}
              isLiked={itemProps.is_liked}
              contractStatus={itemProps.contract_status}
              offerId={itemProps.id}
              yourHighestBet={itemProps.current_dealer_highest_bet}
              buyNowPrice={itemProps.buy_now_contract?.price}
              buyNowContractId={itemProps.buy_now_contract?.id}
              zipCode={itemProps.zip_code}
              countryCode={itemProps.country_code ?? ''}
            />
          )}
          // eslint-disable-next-line require-await
          fetchMore={async () => {
            dispatch(FETCH_OFFERS({ tab: 'browse' }))
            // eslint-disable-next-line @typescript-eslint/return-await
            return Promise.resolve()
          }}
          itemsPerRow={columns === 'more' ? itemsPerRowBase + 1 : itemsPerRowBase}
        />
      )}
    </div>
  )
}

export default InfinitiveGrid
